export default __webpack_public_path__ + "static/media/e28fe5d40d58d762b5e0190eca8e481a.svg";